import { Audiotype } from "./../../containers/ccsmodule/queues/settings/componenets/audioType";
import { Queuetype } from "../../containers/ccsmodule/queues/settings/componenets/queueType";
import { ActiveSupervisorQueueType } from "../action-types/activeSupervisorQueue.action.types";

export const setQueue = (data: Queuetype) => {
  console.log("firstfirstfirstfirst", data);
  return {
    type: ActiveSupervisorQueueType.SET_QUEUE,
    payload: data,
  };
};

export const setCurrentTab = (tab: string) => {
  return {
    type: ActiveSupervisorQueueType.SET_CURRENTTAB,
    payload: tab,
  };
};
export const setAudioLib = (val: Audiotype[]) => {
  return {
    type: ActiveSupervisorQueueType.SET_AUDIOLIB,
    payload: val,
  };
};
export const setPayload = (val: Queuetype) => {
  return {
    type: ActiveSupervisorQueueType.SET_PAYLOAD,
    payload: val,
  };
};

export const setClearFlag = (val: boolean) => {
  return {
    type: ActiveSupervisorQueueType.SET_CLEARFLAG,
    payload: val,
  };
};
